export const V1_SET_DEPARTURE_DATE = 'V1_SET_DEPARTURE_DATE'

export default data => {
  return {
    type: V1_SET_DEPARTURE_DATE,
    data,
  }
}
